import { render, staticRenderFns } from "./PriceGenerate.vue?vue&type=template&id=f020c81a&scoped=true"
import script from "./PriceGenerate.vue?vue&type=script&lang=js"
export * from "./PriceGenerate.vue?vue&type=script&lang=js"
import style0 from "./PriceGenerate.vue?vue&type=style&index=0&id=f020c81a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f020c81a",
  null
  
)

export default component.exports